<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '题目1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: ['（1）请分析当某地禽类中带有禽流感病毒时，哪些人群容易被传染？<span class="title_span">尽可能</span>多地列举出易感人群。（限时5分钟）'],
            durationTime: 5,
            stemContent: [
              {
                type: 'text',
                value: '人们俗称的“鸡瘟”是由禽流感病毒引起的，HA和NA是流感病毒表面的两种糖蛋白。病毒在复制过程中发生物种间遗传物质的基因重组，会获得感染人的能力。目前发现能直接感染人的禽流感病毒亚型有：H5N1、H7N1、H7N2、H7N3、H7N7、H9N2和H7N9亚型。'
              },
              {
                type: 'video',
                id: 1,
                value: [
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    isImg: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/bird_flu_1.mp4',
                    canZoom: true,
                  }
                ]
              },
              {
                type: 'text',
                value: '<b>题目1：</b>人感染禽流感的过程如上图。'
              },
            ],
            askList: [{
              id: 1,
              type: 4,
              title: '易感人群：',
              config: {
                noneInput: true,
                type: 1
              }
            }]
          },
          {
            id: 2,
            title: '(2)',
            desc: ['（2）请将你想到的易感人群按类别拖拽到相应的分类框里，如果你想到的超出列出的这几类，可以点击“+”添加新的分类框。除了已经想到的这些，你能再提出一些新的易感人群吗？请将新想法添加到相应的分类框里。'],
            durationTime: 3,
            stemContent: [
              // {
              //   type: 'text',
              //   value: '人们俗称的“鸡瘟”是由禽流感病毒引起的，HA和NA是流感病毒表面的两种糖蛋白。病毒在复制过程中发生物种间遗传物质的基因重组，会获得感染人的能力。目前发现能直接感染人的禽流感病毒亚型有：H5N1、H7N1、H7N2、H7N3、H7N7、H9N2和H7N9亚型。'
              // },
              // {
              //   type: 'text',
              //   value: '<b>题目1：</b>人感染禽流感的过程如下图。'
              // },
              // {
              //   type: 'img',
              //   value: require('@/assets/exam/7.png')
              // },
              {
                type: 'array'
              }
            ],
            askList: [{
              id: 1,
              type: 8,
              value: '分类',
              title: '请用简要语言对你写出的人群进行分类，并把序号写在类别后面：',
              typeList: [
                {
                  title: '传染源密接/直接人群',
                  disabled: true,
                  children: []
                },
                {
                  title: '传染源次密接/间接人群',
                  disabled: true,
                  children: []
                },
                {
                  title: '缺乏卫生习惯人群',
                  disabled: true,
                  children: []
                },
                {
                  title: '免疫力弱的人群',
                  disabled: true,
                  children: []
                }
              ]
            }]
          }
        ]
      }, {
        qid: 2,
        title: '题目2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 5,
            desc: ['（3）不同的人群都需要口罩。发挥你的想象力，在满足<span class="title_span">口罩防护功能</span>的基础上，针对某个人群设计口罩，并赋予其新的功能，且这个功能是<span class="title_span">其他同学不容易想到的</span>。'],
            stemContent: [
              {
                type: 'text',
                value: '<b>题目2：</b>通常易感人群可以通过勤洗手和佩戴医用口罩等措施进行自我防护。有研究表明，在病毒感染者和易感密接者之间，双方都不戴口罩的传染率为100%，而正确佩戴口罩可以降低传染率至1.5%。'
              },
              {
                type: 'video',
                hasVideoButton: [
                  { text: '情况一' },
                  { text: '情况二' },
                  { text: '情况三' },
                  { text: '情况四' }
                ],
                id: 2,
                value: [
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_2_1_1.mp4'
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_2_1_2.mp4'
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_2_1_3.mp4'
                  },
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_2_1_4.mp4'
                  }
                ]
              }
            ],
            askList: [
              {
                id: 1,
                type: 1,
                noneInput: true,
                isReview: true,
                title: '你的创意口罩适用哪个人群？',
                statsVar: 'top',
                statsNote: '作答区（上）文字录入',
                recordNote: '作答区（上）点击语音录入',
              },
              {
                id: 3,
                type: 1,
                noneInput: true,
                isReview: true,
                title: '你是怎么想到开发口罩的这个功能的？',
                statsVar: 'bottom',
                statsNote: '作答区（下）文字录入',
                recordNote: '作答区（下）点击语音录入',
              }
            ]
          },
          {
            id: 4,
            title: '(4)',
            durationTime: 7,
            desc: ['（4）请清晰、具体地写出你的创意口罩说明书，并用画图的方式解释说明。'],
            stemContent: [
              {
                type: 'text',
                value: '新功能：'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'text',
                value: '适用人群：'
              },
              {
                type: 'text',
                value: ''
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
            },
            {
              id: 2,
              type: 10,
              value: 'draw',
              drawImg: [
                { name: 'KN95口罩', url: require('@/assets/exam/35.png'), clickStats: 'click_n95_mask_button#点击KN95口罩按钮' },
                { name: '医用外科口罩', url: require('@/assets/exam/36.png'), clickStats: 'click_surgical_mask_button#点击医用外科口罩按钮' },
              ],
              // title: '如果需要，可采用设计图呈现你的想法。可画在下发的答题纸上。'
            }]
          }
        ]
      }, {
        qid: 3,
        title: '题目3',
        small: [
          {
            id: 5,
            title: '(5)',
            stemContent: [
              {
                type: 'text',
                value: '<b>题目3：</b>下图是华北A地区往年一次H5N1型禽流感流行病调查的部分结果示意图。圆圈“Ο”代表样本（鸟类或人），箭头“→”表示此次流行病调查的样本之间的相关性，“阳性”表示已感染病毒。'
              },
              {
                type: 'video',
                id: 1,
                value: [
                  {
                    isControl: false,
                    autoPlay: true,
                    isloop: true,
                    isBack: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_3_1_1.mp4'
                  }
                ]
              }
            ],
            durationTime: 5,
            desc: ['（5）假设现在是1月份，有调查信息表明与A地区同在鸟类迁徙路线上的B地区，已检测到H7N9型禽流感样本。如果你是A地区的传染病防控工作人员，会采取哪些措施进行预防？你要努力做到采取的 措施合理有效，且可以执行。'],
            askList: [{
              id: 1,
              type: 11,
              video: [
                {
                  isControl: false,
                  autoPlay: true,
                  isloop: true,
                  url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_3_1_2.mp4'
                }
              ]
            }, {
              id: 2,
              type: 1,
              className: 'inputNmae',
              noneInput: true,
            }],
          },
          {
            id: 6,
            title: '(6)',
            stemContent: [
              {
                type: 'video',
                id: 1,
                value: [
                  {
                    isControl: true,
                    autoPlay: false,
                    isloop: true,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/birdFlu_3_2_v2.mp4'
                  }
                ]
              },
              {
                type: 'text',
                value: '请你先播放说明视频并熟悉右侧操作区的使用方法。'
              }
            ],
            durationTime: 10,
            desc: ['（6）按照你的想法，确定某地区疫情防控可以采取的各项“措施”的参数，然后点击“运行”按钮，演示传染病发展的结果。'],
            askList: [{
              id: 1,
              type: 12,
              title: '你可以尝试这四项“措施”的不同组合，运行并查看结果。可以多次尝试，最后一次运行的结果将被作为你确定采取的方案。'
            }, {
              id: 2,
              type: 1,
              noneInput: true,
              title: '请你简要说出采取上面这种方案的理由。'
            }],
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getAnswer(obj) {
      if (obj.index === 0) {
        this.qidList[1].small[1].stemContent[1].value = obj.text
      } else {
        this.qidList[1].small[1].stemContent[3].value = obj.text
      }
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 2,
        subject_name: '禽流感',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
